import shortid from "shortid"
import * as Objdict from "objdict"
import {units} from "@frog/source/data/units.js"
import player from "@frog/source/data/player.js"

import Stage from "@frog/source/models/Stage.js"
import Tiled from "@frog/source/utility/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/Navigation.js"
import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

// Success/Failure Conditions
// {"type": "defeat-all-unaffiliated-units", "affiliation": "good"}
// {"type": "defeat-all-other-units", "unitKey": "player"}
// {"type": "defeat-unit", "unitKey": "apple"}
// {"type": "wait-x-turns", "turnNumber": 3}
// {"type": "exit", "affiliation": "good"} // YOU'LL NEED TO ADD A METHOD FOR REMOVING UNITS!!

// Step Documentation: See Step.js


function InstantiateUnit({stage, unit}) {
    unit.key = unit.key || shortid.generate()
    unit.mode = "create"
    return [
        {
            "type": "InstantiateUnit",
            "deltastages": [
                // {"unit": unit},
                {"units": {[unit.key]: unit}}
            ]
        }
    ]
}

function reinforcements(unitclasses) {
    return function(stage) {
        let spawns = []
        spawns = Object.values(stage.units).filter((unit) => {
            return unit.class == "spawn-spawn-zone"
        }) //.map((unit) => unit.position)

        // TODO: deprecate this
        if(spawns.length == 0) {
            const zone = stage.encounters[1].zone // TODO: this is so goddamn hacky
            for(let i = 0; i < zone.width; i += 1) {
                spawns.push({
                    "previousPosition": {"x": zone.width - 0, "y": i, "z": 1},
                    "nextPosition": {"x": zone.width - 1, "y": i, "z": 1},
                })
                spawns.push({
                    "previousPosition": {"x": i, "y": zone.height - 0, "z": 1},
                    "nextPosition": {"x": i, "y": zone.height - 1, "z": 1},
                })
            }
        }

        let count = 0
        Object.values(stage.units).forEach((unit) => {
            if(unit.affiliation == "bad"
            && unit.hasBeenRemoved != true
            && unit.isDead != true) {
                count += 1
            }
        })
        if(count >= 15) {
            return
        }

        // TODO: Pull the possible spawn positions from zone units on the tilemap!!
        spawns = spawns.filter((spawn) => {
            // return Stage.hasCollision({stage, "previousPosition": spawn.previousPosition, "nextPosition": spawn.nextPosition}) == false
            return Stage.hasCollision({
                stage,
                "position": spawn.position || spawn.nextPosition,
                "includingSpawnZones": true,
            }) == false
        })
        const spawn = Random.element(spawns)
        if(spawn == undefined) return undefined
        return InstantiateUnit({
            "unit": {
                "class": "spawn-zone",
                "affiliation": "bad",
                "spawnclass": Random.element(unitclasses),
                "position": spawn.position || spawn.nextPosition
            }
        })
    }
}

function getPreservedStateData(stage) {
    return {
        "screen": "EncounterScreen",
        "chapterParty": {
            "units": {
                // TODO: Read these unit keys reactively from player.js
                "donna": {
                    "health": stage.units["donna"].health,
                    "isDead": stage.units["donna"].isDead,
                },
                "blitz": {
                    "health": stage.units["blitz"].health,
                    "isDead": stage.units["blitz"].isDead,
                },
                "z": {
                    "health": stage.units["z"].health,
                    "isDead": stage.units["z"].isDead,
                },
                "jasmine": {
                    "health": stage.units["jasmine"].health,
                    "isDead": stage.units["jasmine"].isDead,
                },
            }
        }
    }
}

function navigateWithPreservedState(path) {
    return function(stage) {
        return {
            "type": "navigate",
            "path": path,
            "data": getPreservedStateData(stage)
        }
    }
}

function say(dialogues) {
    const events = dialogues.map((dialogue) => {
        return {
            "type": "StartDialogue",
            "isImportant": true,
            "duration": Infinity,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": dialogue
                }
            ]
        }
    })
    events.push({
        "type": "FinishDialogue",
        "deltastages": [
            {
                "mark": 0,
                "dialogue": null
            }
        ]
    })
    return events
}

import Ink from "@frog/source/utility/Ink.js"
import InkDialogue from "@frog/source/utility/InkDialogue.js"

function generatePromptToFarmForXTurns(stage) {
    if(stage == undefined) return {}
    const totalTurns = 10 // stage.encounters[1].conditions.find((condition) => condition.type == "wait-x-turns").turnNumber
    const currentTurns = stage.turn.number
    const currentRounds = Math.ceil(currentTurns / 2)
    const remainingTurns = totalTurns - currentTurns
    const remainingRounds = Math.ceil(remainingTurns / 2)
    if(remainingRounds > 0) {
        return {
            "text": "Farm for " + remainingRounds + " round" + (remainingRounds > 1 ? "s" : "")
        }
    } else {
        return {
            "text": "Evacuate?",
            "onClick": function() {
                Director.addEvents(stage, [
                    function() {
                        App.game.encounter.phase = "success"
                    },
                    {"func": function(stage) {Audiomix.trigger("Music:Combat:Done")}},
                    InkDialogue("farming_ends"),
                    {"type": "encounter success"},
                    {
                        "type": "navigate",
                        "path": "/game/town",
                        "data": {
                            "score": Stage.getScore(stage)
                        },
                    },
                ])
            }
        }
    }
    // return currentRounds + (currentRounds >= 10 ? "!" : "")
}

function LostCropsBox(unitKey) {
    return function(stage) {
        if(stage.units[unitKey].score > 0) {
            return [
                {
                    "deltastages": [
                        {
                            "unit": {
                                "key": unitKey,
                                "score": 0,
                            }
                        }
                    ]
                },
                {
                    "type": "StartDialogue",
                    "isImportant": true,
                    "duration": Infinity,
                    "deltastages": [
                        {
                            "mark": 0,
                            "dialogue": {
                                "text": "Dropped " + stage.units[unitKey].score + " crop" + (stage.units[unitKey].score > 1 ? "s" : ""),
                                "type": "popup",
                            },
                        }
                    ]
                },
                {
                    "type": "FinishDialogue",
                    "deltastages": [
                        {
                            "mark": 0,
                            "dialogue": null
                        }
                    ]
                }
            ]
        }
    }
}

function getEncounter({encounterslug}) {
    return {
        1: {
            "slug": 1,
            "zone": {
                "x": 0,
                "y": 0,
                "width": 8,
                "height": 8,
            },
            "events": {
                "encounter:start": [
                    InkDialogue("reset_run"),
                    {"func": function(stage) {
                        player.run = player.run || {}
                        player.run.number = player.run.number + 1 || 0
                        Ink.set("run_number", player.run.number)

                        Object.values(stage.units).forEach((unit) => {
                            if(unit.affiliation == "good"
                            && unit.hasBeenRemoved != true
                            && unit.position.x != -10) {
                                Ink.set(unit.key + "_deployed", true)
                            }
                        })
                    }},
                    InkDialogue("farming_starts"),
                    {"type": "encounter start"},
                    {"func": function(stage) {
                        if(encounterslug == "first_day") {
                            window.tutorial = 0
                        }
                    }}
                ],
                "turn:1:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:A", "intensity": 1})}}],
                "turn:2:start": [
                    {"func": function(stage) {
                        if(encounterslug == "first_day") {
                            window.tutorial2 = 0
                        }
                    }}
                ],
                "turn:3:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:A", "intensity": 2})}}],
                "turn:5:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:A", "intensity": 3})}}],
                "turn:7:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:B", "intensity": 0})}}],
                "turn:9:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:B", "intensity": 1})}}],
                "turn:11:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:B", "intensity": 2})}}],
                "turn:13:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:B", "intensity": 3})}}],
                "turn:15:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:C", "intensity": 0})}}],
                "turn:17:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:C", "intensity": 1})}}],
                "turn:19:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:C", "intensity": 2})}}],
                "turn:21:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:D"})}}],
                "turn:23:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:E", "intensity": 0})}}],
                "turn:25:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:E", "intensity": 1})}}],
                "turn:27:start": [{"func": function(stage) {Audiomix.trigger({"key": "Music:Combat:E", "intensity": 2})}}],
                "turn:every:start": [
                    {"func": (stage) => Ink.set("run_turn_number", stage.turn.number)},
                    InkDialogue("turn_start")
                ],
                "turn:every:end": [
                    InkDialogue("turn_end")
                ],
                "turn:every-odd:end": function(stage) {
                    // Round 1
                    let count = 2
                    let pool = [
                        "spider1"
                    ]

                    // Round 2
                    if(stage.turn.number >= 3) {
                        // No Change
                    }

                    // Round 3 - Dusk
                    if(stage.turn.number >= 5) {
                        pool = [
                            "spider1", "spider1",
                            "slug1"
                        ]
                    }

                    // Round 4
                    if(stage.turn.number >= 7) {
                        // No Change
                    }

                    // Round 5 - Night
                    if(stage.turn.number >= 9) {
                        count = 3
                    }

                    // Round 6
                    if(stage.turn.number >= 11) {
                        pool = [
                            "spider1", "spider1", "spider2",
                            "slug1", "slug1",
                        ]
                    }

                    // Round 7
                    if(stage.turn.number >= 13) {
                        pool = [
                            "spider1", "spider2", "spider2",
                            "slug1", "slug1",
                        ]
                    }

                    // Round 8
                    if(stage.turn.number >= 15) {
                        pool = [
                            "spider1", "spider2", "spider2",
                            "slug1", "slug2"
                        ]
                    }

                    // Round 9
                    if(stage.turn.number >= 17) {
                        // No Change
                    }

                    // Round 10
                    if(stage.turn.number >= 19) {
                        // No Change
                    }

                    // Round 11
                    if(stage.turn.number >= 21) {
                        count = 4
                    }

                    if(encounterslug == "first_day") {
                        count -= 1
                    }

                    let events = []
                    for(let i = 0; i < count; i += 1) {
                        events.push(reinforcements(pool))
                    }
                    return events
                },
                "death:gaurdner": [
                    InkDialogue("gaurdner_has_retreated"),
                ],
                "death:z": [
                    {"func": (stage) => Ink.set("z_survived", false)},
                    InkDialogue("z_has_retreated"),
                    LostCropsBox("z"),
                ],
                "death:jasmine": [
                    {"func": (stage) => Ink.set("jasmine_survived", false)},
                    InkDialogue("jasmine_has_retreated"),
                    LostCropsBox("jasmine"),
                ],
                "death:blitz": [
                    {"func": (stage) => console.log("asdasd")},
                    {"func": (stage) => Ink.set("blitz_survived", false)},
                    InkDialogue("blitz_has_retreated"),
                    LostCropsBox("blitz"),
                ],
                "death:donna": [
                    {"func": (stage) => Ink.set("donna_survived", false)},
                    InkDialogue("donna_has_retreated"),
                    LostCropsBox("donna"),
                ],
                "death:plant": [
                    InkDialogue("plant_was_eaten"),
                ],
                "death:bunnion": [
                    InkDialogue("bunnion_was_eaten"),
                ],
                "death:corndog": [
                    InkDialogue("corndog_was_eaten"),
                ],
                "death:horseradish": [
                    InkDialogue("horseradish_was_eaten"),
                ],
                "death:lobsterkale": [
                    InkDialogue("lobsterkale_was_eaten"),
                ],
                "death:squidbeet": [
                    InkDialogue("squidbeet_was_eaten"),
                ],
                "death:ottermelon": [
                    InkDialogue("ottermelon_was_eaten"),
                ],
                "death:kiwisquash": [
                    InkDialogue("kiwisquash_was_eaten"),
                ],
                "death:musselsprout": [
                    InkDialogue("musselsprout_was_eaten"),
                ],
                "death:urchintomato": [
                    InkDialogue("urchintomato_was_eaten"),
                ],
                "death:bug": [
                    InkDialogue("bug_was_squashed"),
                ],
                "death:spider1": [
                    InkDialogue("spider_1_was_squashed"),
                ],
                "death:spider2": [
                    InkDialogue("spider_2_was_squashed"),
                ],
                "death:slug1": [
                    InkDialogue("slug_1_was_squashed"),
                ],
                "death:slug2": [
                    InkDialogue("slug_2_was_squashed"),
                ],
            },
            "conditions": [
                {
                    "type": "defeat-all-unaffiliated-units",
                    "affiliation": "bad",
                    "events": [
                        function(stage) {
                            App.game.encounter.phase = "failure"
                            Ink.set("run_failed", true)
                        },
                        {"func": function(stage) {Audiomix.trigger("Music:Combat:Done")}},
                        InkDialogue("farming_ends"),
                        {"type": "encounter failure"},
                        {
                            "type": "navigate",
                            "path": "/game/town",
                        },
                    ],
                },
                // {
                //     "type": "wait-x-turns",
                //     "turnNumber": 9,
                //     "events": [
                //         {
                //             "type": "encounter success",
                //         },
                //         {
                //             "type": "navigate",
                //             "path": "/game/chapters",
                //         },
                //     ],
                // },
            ],
        },
    }
}

const chapters = {
    "next_day": {
        "slug": "next_day",
        "name": "Play",
        "isInChapterSelect": 1,

        "hasPreparePhase": true,

        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/farm.tilemap.json"),
                "tileset": require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileset.json"),
            }),

            "prompt": generatePromptToFarmForXTurns,
            "encounters": getEncounter({"encounterslug": "next_day"}),
        },
    },
    "first_day": {
        "slug": "first_day",
        "name": "Learn",
        "isInChapterSelect": 1,

        "hasPreparePhase": false,

        "stage": {
            "world": Tiled.parse({
                "tilemap": require("@frog/source/data/encounters/learn.tilemap.json"),
                "tileset": require("@frog/source/assets/images/apocalypse-tactics/environment/tiles/tileset.json"),
            }),

            "prompt": generatePromptToFarmForXTurns,
            "encounters": getEncounter({"encounterslug": "first_day"}),
        },
    },
}


export default chapters
